import React from 'react';

import './loader.scss';

/**
 * @param {{isLoading: boolean, opacity?: number}} props
 * @returns
 */
const Loader = ({ isLoading, opacity = 0.5 }) => {
  return isLoading ? (
    <div className="loading" style={{ opacity: opacity }} />
  ) : null;
};

export default Loader;
